module.exports = __webpack_public_path__ + "media/hyper/images/attached-files/img-2-d8a2a29aa35df14134f5aa9861f90aef.jpg";